import {Component, OnInit} from '@angular/core';
import {CardModule} from 'primeng/card';
import {NoDataComponent} from '../no-data/no-data.component';

@Component({
  selector: 'app-previous-step-incomplete-notice',
  imports: [CardModule, NoDataComponent],
  templateUrl: './previous-step-incomplete-notice.component.html',
})
export class PreviousStepIncompleteNoticeComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {
    // Intentionally empty as this component is static
  }
}
